import { gql } from 'apollo-angular';

export const RemoveCanvasCategoryDocument = gql`
  mutation removeCanvasCategory($id: Int!) {
    removeCanvasCategory(id: $id)
  }
`;
